import { useRef } from 'react';

const BOUNCE_RATE = 30000;

export const useDebounce = (bounceRate = BOUNCE_RATE) => {
  const busy = useRef(false);

  const setDebounce = async (callback) => {
    setTimeout(() => {
      clearDebounce();
    }, bounceRate);

    if (!busy.current) {
      busy.current = true;
      callback();
    }
  };

  const clearDebounce = () => {
    busy.current = false;
  };

  return { setDebounce, clearDebounce };
};